/**
 * LinkedCampaigns — "Campaigns with this flow" from the drawer tracker's own
 * campaign list. Outside a tracker scope it is the Voluum list, as always.
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FC } from 'react';
import { matchTracker } from '@trafficpulse/shared';

import { useFlowTracker } from '@/features/flow-optimizer/tracker';

import TresCommasLinkedCampaigns from './TresCommasLinkedCampaigns';
import VoluumLinkedCampaigns from './VoluumLinkedCampaigns';

const LinkedCampaigns: FC<{ flowId: string }> = ({ flowId }) => {
  const tracker = useFlowTracker();
  if (!tracker) return <VoluumLinkedCampaigns flowId={flowId} />;
  return matchTracker(tracker, {
    voluum: () => <VoluumLinkedCampaigns flowId={flowId} />,
    // Binom's drawer has its own editor; this panel never mounts there.
    binom: () => null,
    'tres-commas': () => <TresCommasLinkedCampaigns flowId={flowId} />,
  });
};

export default LinkedCampaigns;
